module.exports = __webpack_public_path__ + "img/maestro.84c421bd.png";